// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    id: config.id,
    gitTag: config.gitTag,
    viewerComponentsVersion: config.viewerComponentsVersion,
    coreMapVersion: config.coreMapVersion,
    production: false,
    mockServices: false,
    viewerUrl: config.viewerUrl || "http://localhost:8080/api",
    apiUrl: config.apiUrl || "http://localhost:8080/api",
    geoserverUrl: config.geoserverUrl || "http://localhost:8080",
    appName: config.title || "viewer",
    appKey: config.title || "viewer-app",
    appFlavour: config.appFlavour || "vdp",
    supportEmail: config.supportEmail || "support@vexcelgroup.com",
    defaultInstance: config.instanceId || 1011,
    primaryColor: config.primaryColor || "#518AFF",
    gaTrackId: config.gaTrackId || "",
    module: config.module || "internal",
    mapsKey: config.mapsKey || "",
    eulaUrl: config.eulaUrl || "",
    termOfUse: config.termOfUse || "",
    privacy: config.privacy || "",
    propertyAttributesUrl: config.propertyAttributesUrl || "https://vexceldata.com/products/elements/property-attributes/",
    damageAssessmentUrl: config.damageAssessmentUrl || "https://vexceldata.com/products/elements/damage-assessment/",
    propertyAttributesTemplate: config.propertyAttributesTemplate || "beta_property_default",
    damageAssessmentTemplate: config.propertyAttributesTemplate || "beta_damage_default",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
